import { KoreanContainer, KoreanItem, KoreanPoint } from '../../styles/onBoardStyle';
import Checkbox from './checkbox';

interface MicrositeKoreanPPProps {
	isFirstChecked: boolean;
	checkFirst: (checked: boolean) => void;
	isScndChecked: boolean;
	checkScnd: (checked: boolean) => void;
	checkboxColor?: string;
}

const MicrositeKoreanPP = ({ isFirstChecked, checkFirst, isScndChecked, checkScnd, checkboxColor }: MicrositeKoreanPPProps) => {
	const handleAllCheckClick = () => {
		const nextChecked = !(isFirstChecked && isScndChecked);
		checkFirst(nextChecked);
		checkScnd(nextChecked);
	};

	return (
		<KoreanContainer>
			<KoreanItem $isFirst>
				<Checkbox checked={isFirstChecked && isScndChecked} onChange={handleAllCheckClick} color={checkboxColor} />
				전체 동의하기
			</KoreanItem>

			<KoreanItem>
				<Checkbox checked={isFirstChecked} onChange={(event) => checkFirst(event.target.checked)} color={checkboxColor} />
				<a style={{ color: 'inherit', textDecoration: 'underline' }} target='_blank' rel='noreferrer' href='https://www.cliniquekorea.co.kr/customer-care-privacy-policy'>개인정보 수집 및 이용</a>
				<label> 동의하기 (필수)</label>
			</KoreanItem>

			<KoreanItem $isPoint><KoreanPoint>•</KoreanPoint><label>개인정보 수집 항목: 얼굴 이미지</label></KoreanItem>
			<KoreanItem $isPoint><KoreanPoint>•</KoreanPoint><label>개인정보 수집 및 이용 목적: 가상 체험 서비스 제공, 맞춤형 스킨케어 솔루션 제공 및 관련 제품 추천을 위함</label></KoreanItem>
			<KoreanItem $isPoint><KoreanPoint>•</KoreanPoint><label>개인정보 보유 및 이용 기간: <strong style={{ textDecoration: 'underline' }}>앱 사용 세션 종료 후 즉시 파기</strong></label></KoreanItem>
			<KoreanItem $isPoint><KoreanPoint>•</KoreanPoint><label>개인정보 수집 동의 거부 시 서비스 제한: 위 사항에 동의하지 않을 경우 서비스 이용이 제한될 수 있습니다</label></KoreanItem>

			<KoreanItem>
				<Checkbox checked={isScndChecked} onChange={(event) => checkScnd(event.target.checked)} color={checkboxColor} />
				<label>만 14세 이상입니다 (필수)</label>
			</KoreanItem>
		</KoreanContainer>
	);
};

export default MicrositeKoreanPP;
